import * as CONFIG from './config';


exports.getDocument = function (id) {
    // console.log("getDocumentList==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = param + '/' + id;
        return CONFIG.httpGet('/cds/DocsDetails' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getDocumentList = function (committee_id) {
    // console.log("getDocumentList==>", committee_id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (committee_id && String(committee_id).length > 0)
            param = '/' + committee_id;
        return CONFIG.httpGet('/cds/allDocs' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.addDocument = function (committee_id, objModel) {
    // console.log("addDocument==>");
    return new Promise((resolve, reject) => {
        let param = '';
        if (committee_id && String(committee_id).length > 0)
            param = '/' + committee_id;
        return CONFIG.httpPost('/cds/create' + param, objModel)
            .then(function (response) {
                // console.log('addDocument succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addDocument err==>',err);
                reject(err);
            });
    });
}

exports.updateDocument = function (committee_id, objModel) {
    // console.log("updateDocument==>");
    return new Promise((resolve, reject) => {
        let param = '';
        if (committee_id && String(committee_id).length > 0)
            param = '/' + committee_id;
        return CONFIG.httpPost('/cds/update', objModel)
            .then(function (response) {
                // console.log('updateDocument succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateDocument err==>',err);
                reject(err);
            });
    });
}

exports.updateFile = function (id, objModel) {
    // console.log("updateFile==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpPostFile('/cds/updateExistingFile' + param, objModel)
            .then(function (response) {
                // console.log('updateFile succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateFile err==>',err);
                reject(err);
            });
    });
}

exports.deleteDocument = function (id) {
    // console.log("deleteDocument==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpPost('/cds/deleteFolder' + param)
            .then(function (response) {
                // console.log('deleteDocument succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteDocument err==>',err);
                reject(err);
            });
    });
}

exports.deleteDocumentFile = function (id) {
    // console.log("deleteDocument==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpPost('/cds/deleteFolderFile' + param)
            .then(function (response) {
                // console.log('deleteDocument succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteDocument err==>',err);
                reject(err);
            });
    });
}





// WEBPACK FOOTER //
// ./api/documentdetails.js